import styled from "styled-components";

export const $ModalBodyTabPanelContainer = styled.div`
  padding: 0px 32px 32px;
`;
